import axios from "axios";
import { z } from "zod";

export const qriApi = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: `${import.meta.env.VITE_QRI_SERVICE_HOSTNAME}`,
  withCredentials: true,
});

const QriDetailsResponse = z.record(
  z.string(),
  z
    .object({
      name: z.string(),
      identifiers: z.object({
        code: z.string(),
      }),
    })
    .passthrough(),
);

export type QriDetails = {
  name: string;
  code: string;
};

export const qriApiClient = {
  async resolveQriDetails(
    qris: readonly string[],
  ): Promise<Record<string, QriDetails>> {
    const unique = Array.from(new Set(qris));

    if (!unique.length) {
      return {};
    }

    const response = await qriApi.post("/details", { qris: unique });

    const items = QriDetailsResponse.parse(response.data);

    return Object.fromEntries(
      Object.entries(items).map(([qri, item]) => [
        qri,
        { name: item.name, code: item.identifiers.code },
      ]),
    );
  },
} as const;
